// extracted by mini-css-extract-plugin
module.exports = {"trendingSwiper":"_trendingSwiper_trendingSwiper__nj_39","trending":"_trendingSwiper_trending__0J6J1"};